import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'glxy-empty-state-hero, [glxyEmptyStateHero]',
  standalone: false,
})
export class EmptyStateHeroDirective {
  @HostBinding('class') class = 'glxy-empty-state-hero';
}
